// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Belt_List = require("rescript/lib/js/belt_List.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var Mode$ReactHooksTemplate = require("./mode.res.js");
var SmsMode$ReactHooksTemplate = require("./SmsMode.res.js");
var EmailMode$ReactHooksTemplate = require("./EmailMode.res.js");
var AppLinkMode$ReactHooksTemplate = require("./AppLinkMode.res.js");
var SmsLinkMode$ReactHooksTemplate = require("./SmsLinkMode.res.js");
var WebsiteLinkMode$ReactHooksTemplate = require("./WebsiteLinkMode.res.js");
var WhatsappLinkMode$ReactHooksTemplate = require("./WhatsappLinkMode.res.js");
var AnonymousLinkMode$ReactHooksTemplate = require("./AnonymousLinkMode.res.js");
var ApplicationSetting$ReactHooksTemplate = require("../general_settings/applicationSetting.res.js");
var CampaignsDataField$ReactHooksTemplate = require("../general_settings/campaignsDataField.res.js");

var emptyString = "";

function empty(param) {
  return {
          id: 0,
          uid: emptyString,
          name: emptyString,
          modes: /* [] */0,
          surveyName: emptyString,
          surveyId: 0,
          applicationSettings: /* [] */0,
          redirectionDelay: 500,
          campaignDataFields: /* [] */0,
          surveyVerificationCode: false,
          redirectionType: "automatic",
          redirectionButtonText: undefined,
          redirectionDescription: undefined,
          followUpEnabled: false,
          sendingLimit: 0,
          sendingFrequency: 0,
          followUpModes: /* [] */0,
          followUpConditions: /* [] */0
        };
}

function id(t) {
  return t.id;
}

function uid(t) {
  return t.uid;
}

function name(t) {
  return t.name;
}

function modes(t) {
  return t.modes;
}

function surveyName(t) {
  return t.surveyName;
}

function surveyId(t) {
  return t.surveyId;
}

function campaignDataFields(t) {
  return t.campaignDataFields;
}

function applicationSettings(t) {
  return t.applicationSettings;
}

function redirectionDelay(t) {
  return t.redirectionDelay;
}

function surveyVerificationCode(t) {
  return t.surveyVerificationCode;
}

function followUpEnabled(t) {
  return t.followUpEnabled;
}

function sendingLimit(t) {
  return t.sendingLimit;
}

function sendingFrequency(t) {
  return t.sendingFrequency;
}

function followUpModes(t) {
  return t.followUpModes;
}

function followUpConditions(t) {
  return t.followUpConditions;
}

function redirectionType(t) {
  return t.redirectionType;
}

function redirectionButtonText(t) {
  return t.redirectionButtonText;
}

function redirectionDescription(t) {
  return t.redirectionDescription;
}

function setApplicationSettings(t, xs) {
  return {
          id: t.id,
          uid: t.uid,
          name: t.name,
          modes: t.modes,
          surveyName: t.surveyName,
          surveyId: t.surveyId,
          applicationSettings: xs,
          redirectionDelay: t.redirectionDelay,
          campaignDataFields: t.campaignDataFields,
          surveyVerificationCode: t.surveyVerificationCode,
          redirectionType: t.redirectionType,
          redirectionButtonText: t.redirectionButtonText,
          redirectionDescription: t.redirectionDescription,
          followUpEnabled: t.followUpEnabled,
          sendingLimit: t.sendingLimit,
          sendingFrequency: t.sendingFrequency,
          followUpModes: t.followUpModes,
          followUpConditions: t.followUpConditions
        };
}

function setRedirectionDelay(t, timeout) {
  return {
          id: t.id,
          uid: t.uid,
          name: t.name,
          modes: t.modes,
          surveyName: t.surveyName,
          surveyId: t.surveyId,
          applicationSettings: t.applicationSettings,
          redirectionDelay: timeout,
          campaignDataFields: t.campaignDataFields,
          surveyVerificationCode: t.surveyVerificationCode,
          redirectionType: t.redirectionType,
          redirectionButtonText: t.redirectionButtonText,
          redirectionDescription: t.redirectionDescription,
          followUpEnabled: t.followUpEnabled,
          sendingLimit: t.sendingLimit,
          sendingFrequency: t.sendingFrequency,
          followUpModes: t.followUpModes,
          followUpConditions: t.followUpConditions
        };
}

function setSurveyVerificationCode(t, enabled) {
  return {
          id: t.id,
          uid: t.uid,
          name: t.name,
          modes: t.modes,
          surveyName: t.surveyName,
          surveyId: t.surveyId,
          applicationSettings: t.applicationSettings,
          redirectionDelay: t.redirectionDelay,
          campaignDataFields: t.campaignDataFields,
          surveyVerificationCode: enabled,
          redirectionType: t.redirectionType,
          redirectionButtonText: t.redirectionButtonText,
          redirectionDescription: t.redirectionDescription,
          followUpEnabled: t.followUpEnabled,
          sendingLimit: t.sendingLimit,
          sendingFrequency: t.sendingFrequency,
          followUpModes: t.followUpModes,
          followUpConditions: t.followUpConditions
        };
}

function setCampaignDataFields(t, dfs) {
  return {
          id: t.id,
          uid: t.uid,
          name: t.name,
          modes: t.modes,
          surveyName: t.surveyName,
          surveyId: t.surveyId,
          applicationSettings: t.applicationSettings,
          redirectionDelay: t.redirectionDelay,
          campaignDataFields: dfs,
          surveyVerificationCode: t.surveyVerificationCode,
          redirectionType: t.redirectionType,
          redirectionButtonText: t.redirectionButtonText,
          redirectionDescription: t.redirectionDescription,
          followUpEnabled: t.followUpEnabled,
          sendingLimit: t.sendingLimit,
          sendingFrequency: t.sendingFrequency,
          followUpModes: t.followUpModes,
          followUpConditions: t.followUpConditions
        };
}

function setRedirectionType(t, rType) {
  return {
          id: t.id,
          uid: t.uid,
          name: t.name,
          modes: t.modes,
          surveyName: t.surveyName,
          surveyId: t.surveyId,
          applicationSettings: t.applicationSettings,
          redirectionDelay: t.redirectionDelay,
          campaignDataFields: t.campaignDataFields,
          surveyVerificationCode: t.surveyVerificationCode,
          redirectionType: rType,
          redirectionButtonText: t.redirectionButtonText,
          redirectionDescription: t.redirectionDescription,
          followUpEnabled: t.followUpEnabled,
          sendingLimit: t.sendingLimit,
          sendingFrequency: t.sendingFrequency,
          followUpModes: t.followUpModes,
          followUpConditions: t.followUpConditions
        };
}

function setRedirectionButtonText(t, text) {
  return {
          id: t.id,
          uid: t.uid,
          name: t.name,
          modes: t.modes,
          surveyName: t.surveyName,
          surveyId: t.surveyId,
          applicationSettings: t.applicationSettings,
          redirectionDelay: t.redirectionDelay,
          campaignDataFields: t.campaignDataFields,
          surveyVerificationCode: t.surveyVerificationCode,
          redirectionType: t.redirectionType,
          redirectionButtonText: text,
          redirectionDescription: t.redirectionDescription,
          followUpEnabled: t.followUpEnabled,
          sendingLimit: t.sendingLimit,
          sendingFrequency: t.sendingFrequency,
          followUpModes: t.followUpModes,
          followUpConditions: t.followUpConditions
        };
}

function setRedirectionDescription(t, desc) {
  return {
          id: t.id,
          uid: t.uid,
          name: t.name,
          modes: t.modes,
          surveyName: t.surveyName,
          surveyId: t.surveyId,
          applicationSettings: t.applicationSettings,
          redirectionDelay: t.redirectionDelay,
          campaignDataFields: t.campaignDataFields,
          surveyVerificationCode: t.surveyVerificationCode,
          redirectionType: t.redirectionType,
          redirectionButtonText: t.redirectionButtonText,
          redirectionDescription: desc,
          followUpEnabled: t.followUpEnabled,
          sendingLimit: t.sendingLimit,
          sendingFrequency: t.sendingFrequency,
          followUpModes: t.followUpModes,
          followUpConditions: t.followUpConditions
        };
}

function setFollowupEnabled(t, enabled) {
  return {
          id: t.id,
          uid: t.uid,
          name: t.name,
          modes: t.modes,
          surveyName: t.surveyName,
          surveyId: t.surveyId,
          applicationSettings: t.applicationSettings,
          redirectionDelay: t.redirectionDelay,
          campaignDataFields: t.campaignDataFields,
          surveyVerificationCode: t.surveyVerificationCode,
          redirectionType: t.redirectionType,
          redirectionButtonText: t.redirectionButtonText,
          redirectionDescription: t.redirectionDescription,
          followUpEnabled: enabled,
          sendingLimit: t.sendingLimit,
          sendingFrequency: t.sendingFrequency,
          followUpModes: t.followUpModes,
          followUpConditions: t.followUpConditions
        };
}

function setSendingLimit(t, xs) {
  return {
          id: t.id,
          uid: t.uid,
          name: t.name,
          modes: t.modes,
          surveyName: t.surveyName,
          surveyId: t.surveyId,
          applicationSettings: t.applicationSettings,
          redirectionDelay: t.redirectionDelay,
          campaignDataFields: t.campaignDataFields,
          surveyVerificationCode: t.surveyVerificationCode,
          redirectionType: t.redirectionType,
          redirectionButtonText: t.redirectionButtonText,
          redirectionDescription: t.redirectionDescription,
          followUpEnabled: t.followUpEnabled,
          sendingLimit: xs,
          sendingFrequency: t.sendingFrequency,
          followUpModes: t.followUpModes,
          followUpConditions: t.followUpConditions
        };
}

function setSendingFrequency(t, xs) {
  return {
          id: t.id,
          uid: t.uid,
          name: t.name,
          modes: t.modes,
          surveyName: t.surveyName,
          surveyId: t.surveyId,
          applicationSettings: t.applicationSettings,
          redirectionDelay: t.redirectionDelay,
          campaignDataFields: t.campaignDataFields,
          surveyVerificationCode: t.surveyVerificationCode,
          redirectionType: t.redirectionType,
          redirectionButtonText: t.redirectionButtonText,
          redirectionDescription: t.redirectionDescription,
          followUpEnabled: t.followUpEnabled,
          sendingLimit: t.sendingLimit,
          sendingFrequency: xs,
          followUpModes: t.followUpModes,
          followUpConditions: t.followUpConditions
        };
}

function setFollowupModes(t, xs) {
  return {
          id: t.id,
          uid: t.uid,
          name: t.name,
          modes: t.modes,
          surveyName: t.surveyName,
          surveyId: t.surveyId,
          applicationSettings: t.applicationSettings,
          redirectionDelay: t.redirectionDelay,
          campaignDataFields: t.campaignDataFields,
          surveyVerificationCode: t.surveyVerificationCode,
          redirectionType: t.redirectionType,
          redirectionButtonText: t.redirectionButtonText,
          redirectionDescription: t.redirectionDescription,
          followUpEnabled: t.followUpEnabled,
          sendingLimit: t.sendingLimit,
          sendingFrequency: t.sendingFrequency,
          followUpModes: xs,
          followUpConditions: t.followUpConditions
        };
}

function setFollowUpConditions(t, xs) {
  return {
          id: t.id,
          uid: t.uid,
          name: t.name,
          modes: t.modes,
          surveyName: t.surveyName,
          surveyId: t.surveyId,
          applicationSettings: t.applicationSettings,
          redirectionDelay: t.redirectionDelay,
          campaignDataFields: t.campaignDataFields,
          surveyVerificationCode: t.surveyVerificationCode,
          redirectionType: t.redirectionType,
          redirectionButtonText: t.redirectionButtonText,
          redirectionDescription: t.redirectionDescription,
          followUpEnabled: t.followUpEnabled,
          sendingLimit: t.sendingLimit,
          sendingFrequency: t.sendingFrequency,
          followUpModes: t.followUpModes,
          followUpConditions: xs
        };
}

function decode(json) {
  var delay = Json_decode.withDefault(500, (function (param) {
          return Json_decode.field("redirection_delay", Json_decode.$$int, param);
        }), json);
  return {
          id: Json_decode.field("id", Json_decode.$$int, json),
          uid: Json_decode.field("uid", Json_decode.string, json),
          name: Json_decode.field("name", Json_decode.string, json),
          modes: Json_decode.field("campaign_modes", (function (param) {
                  return Json_decode.list(Mode$ReactHooksTemplate.decoder, param);
                }), json),
          surveyName: Json_decode.field("survey", (function (param) {
                  return Json_decode.field("name", Json_decode.string, param);
                }), json),
          surveyId: Json_decode.field("survey", (function (param) {
                  return Json_decode.field("id", Json_decode.$$int, param);
                }), json),
          applicationSettings: Json_decode.withDefault(/* [] */0, (function (param) {
                  return Json_decode.field("system_settings", (function (param) {
                                return Json_decode.list(ApplicationSetting$ReactHooksTemplate.decode, param);
                              }), param);
                }), json),
          redirectionDelay: delay,
          campaignDataFields: Json_decode.withDefault(/* [] */0, (function (param) {
                  return Json_decode.field("campaigns_data_field", (function (param) {
                                return Json_decode.list(CampaignsDataField$ReactHooksTemplate.decode, param);
                              }), param);
                }), json),
          surveyVerificationCode: Json_decode.withDefault(false, (function (param) {
                  return Json_decode.field("survey_verification_code", Json_decode.bool, param);
                }), json),
          redirectionType: Json_decode.withDefault("automatic", (function (param) {
                  return Json_decode.field("redirection_type", Json_decode.string, param);
                }), json),
          redirectionButtonText: Json_decode.optional((function (param) {
                  return Json_decode.field("redirection_button_text", Json_decode.string, param);
                }), json),
          redirectionDescription: Json_decode.optional((function (param) {
                  return Json_decode.field("redirection_description", Json_decode.string, param);
                }), json),
          followUpEnabled: Json_decode.withDefault(false, (function (param) {
                  return Json_decode.field("follow_up_enabled", Json_decode.bool, param);
                }), json),
          sendingLimit: Json_decode.withDefault(0, (function (param) {
                  return Json_decode.field("sending_limit", Json_decode.$$int, param);
                }), json),
          sendingFrequency: Json_decode.withDefault(0, (function (param) {
                  return Json_decode.field("sending_frequency", Json_decode.$$int, param);
                }), json),
          followUpModes: Json_decode.withDefault(/* [] */0, (function (param) {
                  return Json_decode.field("follow_up_campaign_modes", (function (param) {
                                return Json_decode.list(Mode$ReactHooksTemplate.decoder, param);
                              }), param);
                }), json),
          followUpConditions: /* [] */0
        };
}

function encode(t) {
  var baseFields_0 = [
    "name",
    t.name
  ];
  var baseFields_1 = {
    hd: [
      "system_settings_attributes",
      Json_encode.list(ApplicationSetting$ReactHooksTemplate.encode, t.applicationSettings)
    ],
    tl: {
      hd: [
        "redirection_delay",
        t.redirectionDelay
      ],
      tl: {
        hd: [
          "survey_verification_code",
          t.surveyVerificationCode
        ],
        tl: {
          hd: [
            "redirection_type",
            t.redirectionType
          ],
          tl: /* [] */0
        }
      }
    }
  };
  var baseFields = {
    hd: baseFields_0,
    tl: baseFields_1
  };
  var text = t.redirectionButtonText;
  var withButtonText = text !== undefined ? Belt_List.concat(baseFields, {
          hd: [
            "redirection_button_text",
            text
          ],
          tl: /* [] */0
        }) : baseFields;
  var desc = t.redirectionDescription;
  return Json_encode.object_(desc !== undefined ? Belt_List.concat(withButtonText, {
                    hd: [
                      "redirection_description",
                      desc
                    ],
                    tl: /* [] */0
                  }) : withButtonText);
}

var availableModes_0 = {
  id: undefined,
  mode: {
    TAG: "Email",
    _0: EmailMode$ReactHooksTemplate.empty()
  }
};

var availableModes_1 = {
  hd: {
    id: undefined,
    mode: {
      TAG: "Sms",
      _0: SmsMode$ReactHooksTemplate.empty()
    }
  },
  tl: {
    hd: {
      id: undefined,
      mode: {
        TAG: "SmsLink",
        _0: SmsLinkMode$ReactHooksTemplate.empty()
      }
    },
    tl: {
      hd: {
        id: undefined,
        mode: {
          TAG: "WhatsappLink",
          _0: WhatsappLinkMode$ReactHooksTemplate.empty()
        }
      },
      tl: {
        hd: {
          id: undefined,
          mode: {
            TAG: "AppLink",
            _0: AppLinkMode$ReactHooksTemplate.empty()
          }
        },
        tl: {
          hd: {
            id: undefined,
            mode: {
              TAG: "WebsiteLink",
              _0: WebsiteLinkMode$ReactHooksTemplate.empty()
            }
          },
          tl: {
            hd: {
              id: undefined,
              mode: {
                TAG: "AnonymousLink",
                _0: AnonymousLinkMode$ReactHooksTemplate.empty()
              }
            },
            tl: {
              hd: {
                id: undefined,
                mode: "Telephonic"
              },
              tl: /* [] */0
            }
          }
        }
      }
    }
  }
};

var availableModes = {
  hd: availableModes_0,
  tl: availableModes_1
};

var availableCampaignModes = {
  hd: "Email",
  tl: {
    hd: "Sms",
    tl: {
      hd: "SmsLink",
      tl: {
        hd: "WhatsappLink",
        tl: {
          hd: "AppLink",
          tl: {
            hd: "WebsiteLink",
            tl: {
              hd: "AnonymousLink",
              tl: {
                hd: "Telephonic",
                tl: /* [] */0
              }
            }
          }
        }
      }
    }
  }
};

exports.id = id;
exports.emptyString = emptyString;
exports.uid = uid;
exports.name = name;
exports.modes = modes;
exports.surveyName = surveyName;
exports.surveyId = surveyId;
exports.campaignDataFields = campaignDataFields;
exports.followUpModes = followUpModes;
exports.followUpConditions = followUpConditions;
exports.availableModes = availableModes;
exports.setCampaignDataFields = setCampaignDataFields;
exports.applicationSettings = applicationSettings;
exports.setApplicationSettings = setApplicationSettings;
exports.empty = empty;
exports.decode = decode;
exports.encode = encode;
exports.availableCampaignModes = availableCampaignModes;
exports.redirectionDelay = redirectionDelay;
exports.setRedirectionDelay = setRedirectionDelay;
exports.surveyVerificationCode = surveyVerificationCode;
exports.setSurveyVerificationCode = setSurveyVerificationCode;
exports.followUpEnabled = followUpEnabled;
exports.sendingLimit = sendingLimit;
exports.sendingFrequency = sendingFrequency;
exports.setFollowupModes = setFollowupModes;
exports.redirectionType = redirectionType;
exports.setRedirectionType = setRedirectionType;
exports.redirectionButtonText = redirectionButtonText;
exports.setRedirectionButtonText = setRedirectionButtonText;
exports.redirectionDescription = redirectionDescription;
exports.setRedirectionDescription = setRedirectionDescription;
exports.setFollowupEnabled = setFollowupEnabled;
exports.setSendingLimit = setSendingLimit;
exports.setSendingFrequency = setSendingFrequency;
exports.setFollowUpConditions = setFollowUpConditions;
/* availableModes Not a pure module */
